import React from 'react';
import './convs.css';

const PdfViewer = () => {
  const isMobile = window.innerWidth <= 768; 

  return (
    <div align='center' className="pdf-viewer-container">
      <h2 className="pdf-viewer-title">11.o Concurso Regional de Artesanías de la Huasteca Hidalguense 2024</h2>
      {isMobile ? (
       
       
       <div className="pdf-viewer-mobile">
       <a
         href={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_HH_2024.pdf`}
         download
         className="pdf-viewer-download"
       >
         Descargar PDF
       </a>
     </div>
      ) : (
        // Si no es un dispositivo móvil, mostrar el visor de PDF en un iframe
        <div className="pdf-viewer-wrapper">
          <iframe
            src={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_HH_2024.pdf`}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;